import { Injectable } from '@angular/core';
import { Feature } from '../models/feature';
import { Observable } from 'rxjs';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { RouterModule, Routes, Router } from '@angular/router';

@Injectable()
export class CloudPasswordService {

  constructor(private _http: Http) { }

 private extractData(res: Response) {
  let data
  //console.log(res);
  if (res.text()) {
    data = res.json();
  }
  return data || {};
}

// private handleError(error: Response | any) {
//   // In a real world app, we might use a remote logging infrastructure
//   let errMsg: string;
//   if (error instanceof Response) {
//     const body = error.json() || '';
//     const err = body.error || JSON.stringify(body);
//     errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
//   } else {
//     errMsg = error.message ? error.message : error.toString();
//   }
//   console.error(errMsg);
//   return Observable.throw(errMsg);
// }

private handleError(error: Response | any) {
  // In a real world app, we might use a remote logging infrastructure
  let errMsg: string;
  if (error instanceof Response) {
    
    let body: any;
    try {
      body = error.json();
    } catch (ex) {
      body = error.text();
    } 
    //err = body.error || JSON.stringify(body);
    errMsg = `${error.status} - ${error.statusText || ''} ${body}`;
  } else {
    
    errMsg = error.message ? error.message : error.toString();
  }
  console.error(errMsg);
  return Observable.throw(errMsg);
}

ResetPassword(item: any): Observable<any> {    
  return this._http.post('/api/CloudPasswordReset', item)
    .map(this.extractData)
    .catch(this.handleError);
}

}



// WEBPACK FOOTER //
// ./src/app/services/cloud-password.service.ts